export const ADD_CART_ITEM = 'cartItem/addCartItem';
export const DELETE_CART_ITEM = 'cartItem/deleteCartItem';
export const INCREASE_CART_QUANTITY = 'cartItem/increaseCartQuantity';
export const DECREASE_CART_QUANTITY = 'cartItem/decreaseCartQuantity';
